import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useToast } from '@/src/general/components/ToastContext'
import { useTranslate } from '@/src/lang/useTranslate'

import { intentionApi } from '../../intention/api/intentionApi'
import type { TWatchmanDailyIntentionApi } from '../../intention/api/types/getWatchmanIntentionsApi.types'
import { getWatchmanDailyIntentionsOptions } from './useWatchmanDailyIntentionsQuery'

export const useRefuseIntentionWatchmanMutation = () => {
  const queryClient = useQueryClient()
  const { addToast } = useToast()
  const { t } = useTranslate()

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      intentionApi.refuseIntentionWatchman({
        id,
      }),
    onSuccess: (newWatchmanDailyIntention, { id }) =>
      queryClient.setQueryData(
        getWatchmanDailyIntentionsOptions({ enabled: true }).queryKey,
        (oldData: TWatchmanDailyIntentionApi[] | undefined) => {
          if (!oldData) return oldData
          if (!newWatchmanDailyIntention) return oldData.filter((item) => item.id !== id)
          return oldData.map((assignedIntention) => {
            return assignedIntention.id === id ? newWatchmanDailyIntention : assignedIntention
          })
        },
      ),
    onError: () => {
      addToast({
        colors: 'danger',
        message: t('common.error.unknown'),
      })
    },
  })
}
